import React, { Component } from 'react';
import FormWrapper from '../../../containers/Forms/FormWrapper';
import FormVerificationPhoneEmail from '../../../containers/Forms/FormVerificationPhoneEmail';
import { entityNames } from '../../../config/constants';

class Stage1 extends Component {
  componentDidMount() {
    const { fetchReset } = this.props;
    if (fetchReset) {
      fetchReset(entityNames.SEND_PASSWORD_RESET_CODE);
    }
  }

  render() {
    const { t, sendPasswordResetCode } = this.props;
    return (
      <div className="reset-stage">
        <h2 className="reset-stage-title">{t('resetPassword:verification')}</h2>
        <p className="reset-stage-description">
          {t('resetPassword:willSendYouCode')}
        </p>
        <FormWrapper
          entityName={entityNames.SEND_PASSWORD_RESET_CODE}
          entity={['emailOrPhone', 'smsOrCall']}
          onSubmit={sendPasswordResetCode}
          noValidation={true}
        >
          <FormVerificationPhoneEmail />
        </FormWrapper>
      </div>
    );
  }
}

export default Stage1;
